import { render } from "./captha.vue?vue&type=template&id=59aeb0ca&scoped=true"
import script from "./captha.vue?vue&type=script&lang=js"
export * from "./captha.vue?vue&type=script&lang=js"

import "./captha.vue?vue&type=style&index=0&id=59aeb0ca&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59aeb0ca"]])

export default __exports__